import React, { useEffect, useState } from "react";
import { listAttendance, addAttendance } from "../../../services/attendance";
import {
  roleList,
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
} from "../../../services/master";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { academylist } from "../../../services/admin";
import moment from "moment";
import { pushcreate, smslist } from "../../../services/common";
import messagetemplate from "../../messagetemplate.json"

export default function Addattendance() {
  const [AccademicYearList, setAccademicYearList] = useState([]);
  const [StudentClassList, setStudentClassList] = useState([]);
  const [StudentDivisionList, setStudentDivisionList] = useState([]);

  const [attendancelist, SetAttendancelist] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [triggerattebdence, setTriggerattebdence] = useState(false);

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [ssms, setSSms] = useState(false);
  const [spush, setSPush] = useState(true);


  const [attendence, setAttendence] = useState({
    year: localStorage.getItem("AYear") != null ? localStorage.getItem("AYear") : "",
    class: "",
    section: "",
    date: moment(localStorage.getItem("ADate") || new Date()).format("YYYY-MM-DD"),
    time: "",
  });
  const [wlist, setWlist] = useState([]);
  const [wtype, setWType] = useState("");

  useEffect(() => {
    roleList().then((res) => {
      if (res.status === true) {
        setWlist(res.data);
      }
    });

    stuclasslist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].class_name,
            });
          }
          setStudentClassList(arr);
        }
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setStudentDivisionList(arr);
        }
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });


    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listall(arr[0]);

              }
            }

          }
        }
      });
    } else {
      listall("");
    }

  }, []);

  const submitattendancelist = () => {
    SetAttendancelist([]);
    if (validation()) {
      const formData = new FormData();
      formData.append("role", wtype);
      formData.append("year", attendence.year);
      formData.append("date", attendence.date);
      formData.append("type", attendence.time);
      if (wtype == 4) {
        formData.append("class", attendence.class);
        formData.append("section", attendence.section);
      } else {
        formData.append("class", 0);
        formData.append("section", 0);
      }
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        formData.append("academy", acaid.value);
      }
      // NOTE: The "Already Marked the Attendance" guard is enforced by the
      // backend /studentattendance endpoint. This handler is role-agnostic —
      // it shows res.message for any role (student=4, teacher=5, employee>5)
      // whenever res.status === false. For the alert to appear for teacher/
      // employee roles, the backend must run the same "already marked"
      // existence check (keyed on role + year + date + type, without class/
      // section for non-student roles) and return status:false with that message.
      listAttendance(formData).then((res) => {
        setTriggerattebdence(true);
        if (res.status === false) {
          toast.error(res.message);
          return;
        }
        let updatedData = res.data.map((student) => ({
          ...student,
          status: 1,
        }));
        // For students, sort boys first (alphabetical), then girls (alphabetical),
        // with any other gender last.
        if (wtype == 4) {
          const genderRank = (g) => {
            const val = (g || "").toString().trim().toLowerCase();
            if (val === "male") return 0;
            if (val === "female") return 1;
            return 2;
          };
          updatedData = [...updatedData].sort((a, b) => {
            const rankDiff = genderRank(a.gender) - genderRank(b.gender);
            if (rankDiff !== 0) return rankDiff;
            return (a.student_name || "").localeCompare(b.student_name || "", undefined, {
              sensitivity: "base",
            });
          });
        }
        SetAttendancelist(updatedData);
      });
    }
  };
  const validation = () => {

    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        toast.error("Please Select Academy");
        return false;
      }
    }
    if (wtype === "") {
      toast.error("Please Select Role.");
      return false;
    }
    if (attendence.year === "") {
      toast.error("Please Select Academic Year.");
      return false;
    }
    if (attendence.class === "" && wtype == 4) {
      toast.error("Please Select Class.");
      return false;
    }
    if (attendence.section === "" && wtype == 4) {
      toast.error("Please Select Section.");
      return false;
    }
    if (attendence.date === "") {
      toast.error("Please Select Date.");
      return false;
    }
    if (attendence.time === "") {
      toast.error("Please Select Time.");
      return false;
    }
    return true;
  };

  const handleAttendanceChange = (studentId, value) => {
    SetAttendancelist((prevList) =>
      prevList.map((item) =>
        item.id === studentId ? { ...item, status: value } : item
      )
    );
  };

  const handleRemarkChange = (studentId, value) => {
    SetAttendancelist((prevList) =>
      prevList.map((item) =>
        item.id === studentId ? { ...item, remark: value } : item
      )
    );
  };
  const navigate = useNavigate();
  const submitFinalAttendance = () => {

    if (validation()) {
      setLoading(true);
      const temp = new FormData();
      temp.append("role", wtype);
      temp.append("date", attendence.date);
      temp.append("time", attendence.time);
      temp.append("count", attendancelist.length);
      temp.append("year", attendence.year);
      if (wtype == 4) {
        temp.append("class", attendence.class);
        temp.append("section", attendence.section);
      } else {
        temp.append("class", 0);
        temp.append("section", 0);
      }

      temp.append("user_id", localStorage.getItem("UID"));
      for (let i = 0; i < attendancelist.length; i++) {
        temp.append("id_" + [i + 1], attendancelist[i].id);
        temp.append("status_" + [i + 1], attendancelist[i].status);
        if (attendancelist[i].remark) {
          temp.append("remark_" + [i + 1], attendancelist[i].remark);
        }
      }
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy", acaid.value);
      }
      addAttendance(temp).then((res) => {
        if (res.status === true) {

          setLoading(false);
          toast.success(res.message);
          if (ssms && wtype == 4) {
            const temp1 = new FormData();
            temp1.append("template_id", "1707176353727142911");
            temp1.append("academy_id", localStorage.getItem("AAcademy"));
            temp1.append("role_id", 4);
            temp1.append("class_id", attendence.class);
            temp1.append("section", attendence.section);
            temp1.append("emp_id", "");
            temp1.append("role_id", 4);
            temp1.append("date", attendence.date);
            temp1.append("type", "attendance");
            temp1.append("message", "Dear Parent, {#var#} is absent on {#var#}. Kindly send leave letter with your ward - {#var#}. AMYTEC");
            smslist(temp1).then((res) => {
              if (res.status === true) {
                toast.success(res.message);
              }
            })
          }

          if (spush) {
            const roleTitle = wtype == 4 ? "Student Attendance Alert" : wtype == 5 ? "Teacher Attendance Alert" : "Employee Attendance Alert";
            let clsname = "";
            let secname = "";
            if (wtype == 4) {
              clsname = StudentClassList.find(item => item.value == attendence.class)?.label || "";
              secname = StudentDivisionList.find(item => item.value == attendence.section)?.label || "";
            }
            const roleMsg = wtype == 4
              ? "Attendance for class " + clsname + " section " + secname + " on " + attendence.date + " ( " + attendence.time + " ) has been marked."
              : "Attendance on " + attendence.date + " ( " + attendence.time + " ) has been marked.";

            const temp1 = new FormData();
            temp1.append("title", roleTitle);
            temp1.append("push_sent_role", wtype);
            temp1.append("priority", "High");
            temp1.append("message", roleMsg);
            temp1.append("academy_id", localStorage.getItem("AAcademy"));
            temp1.append("push_file", "");
            temp1.append("type", "Attendance");
            temp1.append("time", attendence.time);
            temp1.append("role_id", wtype);
            temp1.append("date", attendence.date);
            if (wtype == 4) {
              temp1.append("class_id", attendence.class);
              temp1.append("section_id", attendence.section);
              temp1.append("class_name", clsname);
              temp1.append("section_name", secname);
            }
            attendancelist.forEach((item, index) => {
              const userId = wtype == 5 ? item.teacher_id : item.user_id;
              const name = wtype == 4 ? item.student_name : wtype == 5 ? item.teacher_name : item.worker_name;
              temp1.append("student_ids[]", userId);
              temp1.append("student_name_" + (index + 1), name || "");
              temp1.append("status_" + (index + 1), item.status == 0 ? "Absent" : "Present");
            });

            pushcreate(temp1).then((res) => {
              if (res.status === true) {
                toast.success(res.message);
              }
              navigate('/attendance/allattendance');
            });
          } else {
            navigate('/attendance/allattendance');
          }

          // if (wtype == 4) {
          //           const temp = new FormData();
          //           temp.append("message", message);

          //           temp.append("template_id", "");
          //           temp.append("academy_id", localStorage.getItem("AAcademy"));
          //           temp.append("role_id", wtype);
          //           temp.append("class_id", attendence.class);
          //           temp.append("section", attendence.section);
          //           temp.append("emp_id", "0");
          //           temp.append("message", "");
          //           setLoading(true);
          //           smslist(temp).then((res) => {
          //               if (res.status === true) {
          //                   setLoading(false);
          //                   toast.success(res.message);
          //                   // navigate("/communication/sendsms");
          //               }
          //           })
          //         }
        } else {
          toast.error(res.message);
          setLoading(false);
        }
      });
    }
  };
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");

    }
  }

  function listall(aid) {
    setAccademicYearList([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
          setAccademicYearList(arr);
        }
      }
    });
  }
  const [loading, setLoading] = useState(false);
  const handleCheckAll = (e) => {
    setSSms(e.target.checked);
  };

  const handlePushAll = (e) => {
    setSPush(e.target.checked);
  };
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add Attendance</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Attendance</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add Attendance
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  Add Attendance
                </h2>
              </div>
              <div className="card-body">
                <div className="row">
                  {localStorage.getItem("Role") === "1" && (
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Select Academy{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={alist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Academic Year
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        onChange={(e) =>
                          setAttendence((prevState) => ({
                            ...prevState,
                            year: e.target.value,
                          }))
                        }
                        value={attendence.year}
                        className="default-select form-control wide"
                      >
                        <option value="" disabled>
                          Select Academic Year
                        </option>
                        {AccademicYearList.map((classItem) => (
                          <option
                            key={classItem.value}
                            value={classItem.value}
                          >
                            {classItem.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {localStorage.getItem("Role") !== "5" && (
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Role
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          value={wtype}
                          onChange={(e) => { setWType(e.target.value); SetAttendancelist([]); }}
                        >
                          <option value="" disabled>
                            Select Role
                          </option>

                          {wlist
                            .filter(item => item.id > 3)
                            .filter(item => item.id !== 9)
                            .map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}

                        </select>
                      </div>
                    </div>
                  )}
                  {localStorage.getItem("Role") === "5" && (
                    <div className="col-xl-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Role
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className="default-select form-control wide"
                          value={wtype}
                          onChange={(e) => { setWType(e.target.value); SetAttendancelist([]); }}
                        >
                          <option value="" disabled>
                            Select Role
                          </option>

                          {wlist
                            .filter(item => item.id === 4)
                            .map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}

                        </select>
                      </div>
                    </div>
                  )}
                  {wtype == 4 &&
                    <>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Class<span className="text-danger"> *</span>
                          </label>
                          <select
                            onChange={(e) => {
                              SetAttendancelist([]);
                              setAttendence((prevState) => ({
                                ...prevState,
                                class: e.target.value,
                              }))
                            }
                            }
                            value={attendence.class}
                            className="default-select form-control wide"
                          >
                            <option value="" disabled>
                              Select Class
                            </option>
                            {StudentClassList.map((classItem) => (
                              <option
                                key={classItem.value}
                                value={classItem.value}
                              >
                                {classItem.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Section<span className="text-danger"> *</span>
                          </label>
                          <select
                            onChange={(e) => {
                              SetAttendancelist([]);
                              setAttendence((prevState) => ({
                                ...prevState,
                                section: e.target.value,
                              }))
                            }
                            }
                            value={attendence.section}
                            className="default-select form-control wide"
                          >
                            <option value="" disabled>
                              Select Section
                            </option>
                            {StudentDivisionList.map((classItem) => (
                              <option
                                key={classItem.value}
                                value={classItem.value}
                              >
                                {classItem.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </>
                  }

                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Date<span className="text-danger"> *</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={attendence.date}
                        onChange={(e) =>
                          {
                              SetAttendancelist([]);
                          setAttendence((prevState) => ({
                            ...prevState,
                            date: e.target.value,
                          }))
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Attendance Time
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        value={attendence.time}
                        onChange={(e) =>
                          {
                              SetAttendancelist([]);
                          setAttendence((prevState) => ({
                            ...prevState,
                            time: e.target.value,
                          }))
                        }}
                        className="default-select form-control wide"
                      >
                        <option value="" disabled>
                          Select Attendance Time
                        </option>
                        <option value="Morning">Morning</option>
                        <option value="Evening">Evening</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-xl-12 col-sm-12">
                    <div className="text-right mt-5">
                      <a
                        className="btn btn-success"
                        onClick={submitattendancelist}
                      >
                        Submit
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {triggerattebdence && attendancelist.length > 0 && (

              <div className="mt-2">
                  <div className="text-right">
                    <input type="checkbox" className="styled-checkbox" id="checkbox1" checked={spush} onChange={handlePushAll} /> Send Push Notification &nbsp;&nbsp;
                    <input type="checkbox" className="styled-checkbox" id="checkbox2" checked={ssms} onChange={handleCheckAll} /> Send SMS
                  </div>
                  {/* onChange={handleCheckAll} checked={allChecked} */}
                  <div className="table-responsive tasks">
                    <table className="table card-table table-vcenter text-nowrap mb-0  border">
                      <thead>
                        <tr>
                          <th className="wd-lg-5p text-center">S.No</th>
                          {wtype == 4 && <th className="wd-lg-10p text-center">Roll No</th>}
                          {wtype == 5 && <th className="wd-lg-10p text-center">Teacher Code</th>}
                          {wtype > 5 && <th className="wd-lg-10p text-center">Employee Code</th>}

                          <th className="wd-lg-20p text-center">Name</th>
                          <th className="wd-lg-20p text-center">Attendance</th>
                          <th className="wd-lg-20p text-center">Remark</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attendancelist.map((student, index) => (
                          <tr key={student.id}>
                            <td className="text-center">{index + 1}</td>
                            {wtype == 4 && <td className="text-center">{student.roll_number}</td>}
                            {wtype == 5 && <td className="text-center">{student.teacher_code}</td>}
                            {wtype > 5 && <td className="text-center">{student.employee_id}</td>}

                            <td className="text-center">
                              {wtype == 4 ? student.student_name : wtype == 5 ? student.teacher_name : student.worker_name}
                            </td>
                            <td className="text-center">
                              <select
                                className="default-select form-control wide"
                                onChange={(e) =>
                                  handleAttendanceChange(
                                    student.id,
                                    e.target.value
                                  )
                                }
                                value={student.status}
                              >
                                <option value="" disabled>
                                  Select Attendance
                                </option>
                                <option value={1}>Present</option>
                                <option value={0}>Absent</option>
                              </select>
                            </td>
                            <td className="text-center">
                              <div className="mb-6">
                                <input
                                  placeholder="Enter Remark"
                                  type="text"
                                  className="form-control"
                                  onChange={(e) =>
                                    handleRemarkChange(student.id, e.target.value)
                                  }
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="res-right mt-2">
                    <button
                      className="btn btn-success"
                      onClick={submitFinalAttendance}
                    >
                      Submit
                    </button>
                  </div>
              </div>
            )}

            {triggerattebdence && attendancelist.length == 0 &&
              <h4 className="text-center text-danger">No Records Found</h4>
            }
          </div>
        </div>
      }

    </div>
  );
}
